import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { CASHBACK_STATUS } from '@woovi/shared';
import { Ribbon } from '@woovi/ui';
import { convertToCurrency } from '@woovi/utils';

import type { PaymentLinkActiveEarnCashbackFidelity_charge$key } from './__generated__/PaymentLinkActiveEarnCashbackFidelity_charge.graphql.ts';

import type { ReactNode } from 'react';

type PaymentLinkActiveEarnCashbackFidelityProps = {
  charge: PaymentLinkActiveEarnCashbackFidelity_charge$key;
};
const PaymentLinkActiveEarnCashbackFidelity = (
  props: PaymentLinkActiveEarnCashbackFidelityProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const charge = useFragment<PaymentLinkActiveEarnCashbackFidelity_charge$key>(
    graphql`
      fragment PaymentLinkActiveEarnCashbackFidelity_charge on Charge {
        cashbackExclusive {
          percentage
          value
          status
        }
      }
    `,
    props.charge,
  );

  if (!charge?.cashbackExclusive) {
    return null;
  }

  if (charge.cashbackExclusive?.status !== CASHBACK_STATUS.PENDING) {
    return null;
  }

  const earnCashbackExclusiveValue = convertToCurrency(
    charge.cashbackExclusive.value / 100,
  );

  return (
    <Ribbon color={theme.palette.warning.light}>
      <Typography>🎁</Typography>
      <Typography color={theme.palette.tertiary.main} sx={{ fontSize: '16px' }}>
        <b>{earnCashbackExclusiveValue}</b>{' '}
        {t('of cashback on the next purchase!')}
      </Typography>
    </Ribbon>
  );
};

export default PaymentLinkActiveEarnCashbackFidelity;
